var _rect, _g, _rect2, _circle, _circle2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1120,
    height: 560,
    viewBox: "0 0 28 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 14,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#CC0001"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    width: 28,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    y: 2,
    width: 28,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    y: 4,
    width: 28,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    y: 6,
    width: 28,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    y: 8,
    width: 28,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    y: 10,
    width: 28,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    y: 12,
    width: 28,
    height: 1
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 7,
    fill: "#010066"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.4,
    cy: 3.5,
    r: 2.3,
    fill: "#FFCC00"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.4,
    cy: 3.5,
    r: 1.9,
    fill: "#010066"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFCC00",
    d: "M9.7 3.5l.5.9 1-.2-.6.8.6.8-1-.2-.5.9-.5-.9-1 .2.6-.8-.6-.8 1 .2z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMy);
export default __webpack_public_path__ + "static/media/my.4b3b4d9df54940741bc9a0f6a0168f80.svg";
export { ForwardRef as ReactComponent };